import React from 'react';

const ServiceCard = ({ icon, title, description, items }) => {
  return (
    <div className="group bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-sm hover:shadow-soft transition-all duration-300 border border-slate-100 dark:border-slate-700 hover:-translate-y-1">
      <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300 text-primary">
        <i className={`${icon} text-2xl`}></i>
      </div>

      <h3 className="font-display font-bold text-xl text-slate-900 dark:text-white mb-3">
        {title}
      </h3>

      <p className="text-sm text-slate-500 dark:text-slate-400 mb-6 leading-relaxed">
        {description}
      </p>

      <ul className="space-y-3">
        {items.map((item, index) => (
          <li key={index} className="flex items-start text-sm text-slate-600 dark:text-slate-300">
            <i className="fas fa-check text-secondary mt-1 mr-3 text-xs"></i>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;
